import { BrowserRouter } from 'react-router-dom'
import { CustomRoutes } from 'routes/CustomRoutes'
import { Providers } from 'providers/Providers'

import './styles.css'

export default function Root() {
  return (
    <Providers>
      <BrowserRouter>
        <CustomRoutes />
      </BrowserRouter>
    </Providers>
  )
}
